// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../../../../auth/fragments/customerRegistrationResponse.generated';
export const AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc = gql`
    fragment addToCartReadyToGoRingSuccessNewCustomer on AddToCartReadyToGoRingSuccessNewCustomer {
  __typename
  customer {
    ...customerRegistrationResponse
  }
}
    ${CustomerRegistrationResponseFragmentDoc}`;